module.exports = __webpack_public_path__ + "img/fundingResolutionLogo4.dc925d1d.png";